import React, { useState, useEffect, useRef } from "react";
import UploadIn from '../../assets/images/icon/UploadIp.svg';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField, } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError, mixed } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import {
  Box,
  Button,
  CircularProgress,
  colors,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import { getMethod, postMethod, postMethodFormData } from "../../../services/apiService";
import * as Yup from "yup";
import { getPartnetId } from "../../../services/authService";
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { useNavigate } from "react-router-dom";
import { clearStorageAndCookies } from "../../../services/authService";
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../../services/placeService";
import { AlertDialogs } from "../../dialogs/alertDialogs";
import { PROFILE_TYPE } from "../../../helper/globalConstant";
import { allTimezones  } from "react-timezone-select";
import noteIcon from "../../../assets/images/noteIcon.svg";


function OrderCreateStep1SiteDevice(props: any) {
  const { setToast } = useToastContext() as ToastContext;
  const navigate = useNavigate();
  const [siteType, setSiteType] = useState("1")
  const [customers, setCustomers] = useState([]);
  const [enterpriseId, setEnterpriseId] = useState();
  const [sites, setSites] = useState([]);
  const [partnerId, setPartnerId] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState("")
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState("");
  const [stateList, setStateList] = useState([]);
  const [filteredStateList, setFilteredStateList] = useState([]);
  const [state, setState] = useState("");
  const [cityList, setCityList] = useState([]);
  const [filteredCityList, setFilteredCityList] = useState([]);
  const [city, setCity] = useState("");
  const [customerTimeZone, setCustomerTimeZone] = useState("");
  const [customerSiteList, setCustomerSiteList] = useState([]);

  function getTimezoneOffset(zone: string) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    const parts = formatter.formatToParts(now);
    const localHour = Number(parts.find((p) => p.type === "hour")?.value);
    const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

    const utcHour = now.getUTCHours();
    const utcMinute = now.getUTCMinutes();

    const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
    return totalMinutes;
  }

  function formatOffset(minutes: number) {
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, "0");
    const mins = String(abs % 60).padStart(2, "0");
    return `UTC${sign}${hours}:${mins}`;
  }

  const timezoneList = Object.keys(allTimezones).map((zone) => {
    const offsetInMinutes = getTimezoneOffset(zone);
    const formatted = formatOffset(offsetInMinutes);

    return {
      label: `(${formatted}) ${zone}`,
      value: zone,
    };
  });

  const handleSiteChange = async (e: any, setFieldValue: any) => {
    const selectedSite = e.target.value; // Assume it's an object with name and id
    setFieldValue("siteId", selectedSite)
    const siteData: any = customerSiteList?.find((item: any) => item?.siteId == selectedSite);
    props.setSiteInfo(siteData);
  }


  const handleSelectCustomer = async (e: any, setFeildValue: any) => {
    const selectedCustomer = e.target.value; // Assume it's an object with name and id
    const cumstomerInfo: any = customers.find((customer: any) => customer.name === selectedCustomer);
    if (cumstomerInfo) {
      
      setFeildValue("enterpriseid", cumstomerInfo.id); // Access id only if cumstomerInfo is not undefined
      setEnterpriseId(cumstomerInfo.id);
      setCustomerTimeZone(cumstomerInfo.timezone);
    }
    setSelectedCustomer(selectedCustomer); // Set the customer name
  };



  useEffect(() => {
    fetchCustomerList();
    fetchPartnerId();
    getCountryList();
    getStateList();
    getCityList();
  }, []);


  const getCountryList = async () => {
    const resp = await getCountriesAPI();
    setCountryList(resp.countries);
  }


  const getStateList = async () => {
    const resp = await getStatesAPI();
    setStateList(resp.states);
  }


  const getCityList = async () => {
    const resp = await getCitiesAPI();
    setCityList(resp.cities);
  }


  const handleCountryChange = async (e: any, setFieldValue: any) => {
    const selectedCountryId = e.target.value;
    const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
    setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
    setFieldValue("country", selectedCountry.id.toString());

    setTimeout(() => {
      const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
      props.setFilteredStateList(filteredStates);
      setFilteredStateList(filteredStates);
    }, 200);
  }


  const handleStateChange = async (e: any, setFieldValue: any) => {
    const selectedStateId = e.target.value;
    const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
    setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
    setFieldValue("state", selectedState.id.toString());

    setTimeout(() => {
      const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
      props.setFilteredCityList(filteredCities);
      setFilteredCityList(filteredCities);
    }, 200);
  }


  const handleCityChange = async (e: any, setFieldValue: any) => {
    const selectedCityId = e.target.value;
    const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
    setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
    setFieldValue("city", selectedCity.id.toString());
  }

  
  const handleTimeZoneChange = async (e: any, setFieldValue: any) => {

    setCustomerTimeZone(e.target.value);
    setFieldValue("timezone", e.target.value);
  }

  const fetchPartnerId = async () => {
    const id = await getPartnetId();
    setPartnerId(id);
  }


  useEffect(() => {
    if (enterpriseId !== undefined && partnerId !== undefined) fetchSiteDevice()
  }, [enterpriseId, partnerId]);



  const fetchSiteDevice = async () => {
    let partnerInfo
    const sess_user_data = localStorage.getItem("sess_user");
    if (sess_user_data != null) {
        try {
            const sess_user = JSON.parse(sess_user_data);
            const extractedProfileId = sess_user?.userProfile;
            if (extractedProfileId) {
            const priority = extractedProfileId?.priority;
            if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                partnerInfo = extractedProfileId?.ownerId;
            } else if (priority == PROFILE_TYPE.SUPER_ADMIN || priority == PROFILE_TYPE.INTEGRATOR){
                partnerInfo = partnerId
            }
            } else {
                console.error("Priority id not found in userProfile");
            }
        } catch (error) {
            console.error("Error parsing session user data:", error);
        }
    }
    try {
      const resp = await getMethod("/customer/site/siteswithoutorders/partnerid/" + partnerInfo + "/enterpriseid/" + enterpriseId);
      if (resp?.status === 200) {
        const siteDetails = resp?.data?.result.map((site: { name: any; siteId: any; }) => ({
          name: site.name,
          siteId: site.siteId,
        }));

        setCustomerSiteList(resp?.data?.result);
        props.setCustomerWiseSiteList(siteDetails);
        setSites(siteDetails)
      } else {
        setToast(resp?.data?.message, "error");
      }
    } catch (error) {
      console.error("Error fetching customer list:", error);
    }
  }



  const fetchCustomerList = async () => {
    try {
      const resp = await getMethod("customer");
      if (resp?.status === 200) {
        let cus = resp?.data?.result?.map((item: any) => ({
          name: item.vEnterprise?.name,
          id: item.vEnterprise?.enterpriseid,
          timezone: item.vEnterprise?.timezone,
        }))
        console.log(cus);
        //props.setCustomers(cus);
        setCustomers(cus);
      } else {
        setToast(resp?.data?.message, "error");
      }
    } catch (error) {
      console.error("Error fetching customer list:", error);
    }
  };


  const [orderInitial, setOrderInitial] = useState({
    "customer": '',
    "orderName": '',
    "orderRef": '',
    "siteId": '',
  });


  const validationSchemaForOrder = Yup.object({
    customer: Yup.string().nullable().required("Customer is required!"),
    // orderName: Yup.string().required("Order name is required!"),
    orderName: Yup.string().trim().optional(),
    orderRef: Yup.string().trim().optional(),
    siteId: Yup.number().required("Site id is required!"),
  });


  const [siteInitial, setSiteInitial] = useState({
    "orderName": '',
    "orderRef": '',
    "customer": '',
    "enterpriseid": enterpriseId,
    "name": '',
    "uniqueid": '',
    "email": '',
    "type": 'EDGE',
    "addressline1": '',
    "postalcode": '',
    "city": '',
    "state": '',
    "country": '',
    "timezone": customerTimeZone,
  });

  const validationSchemaForSite = Yup.object({
    // orderName: Yup.string().required("Order name is required!"),
    orderName: Yup.string().trim().optional(),
    orderRef: Yup.string().trim().optional(),
    customer: Yup.string().trim().required("Customer is required!"),
    enterpriseid: Yup.string().trim().required("Enterprise ID is required!"),
    name: Yup.string().trim().required("Site name is required!"),
    uniqueid: Yup.string().trim().required("Unique ID is required!"),
    // email: Yup.string().email().required("Email ID is required!"),
    type: Yup.string().required("Type is required!"),
    number: string().trim().matches(/^\d{2,10}$/, "Number must be between 2 to 10 digits").optional(),
    addressline1: Yup.string().trim().optional(),
    postalcode: Yup.string().trim().optional(),
    city: Yup.string().trim().optional(),
    state: Yup.string().trim().optional(),
    country: Yup.string().trim().optional(),
  });

  useEffect(() => {
    if (partnerId !== undefined) setOrderInitial(prvdata => ({ ...prvdata, partnerId: partnerId }));
  }, [partnerId]);


  const handleOrderName = (value: string, setFeildValue: any, siteType: string) => {
    setFeildValue("orderName", value);

    if (siteType === "1") {
      setSiteInitial((prvData: any) => {
        return { ...prvData, orderName: value }
      })
    } else {
      setOrderInitial((prvData: any) => {
        return { ...prvData, orderName: value }
      })
    }
  }


  const handleOrderRef = (value: string, setFeildValue: any, siteType: string) => {
    setFeildValue("orderRef", value);

    if (siteType === "1") {
      setSiteInitial((prvData: any) => {
        return { ...prvData, orderRef: value }
      })
    } else {
      setOrderInitial((prvData: any) => {
        return { ...prvData, orderRef: value }
      })
    }
  }




  const handleSiteTypeChange = (site: any, values: any) => {
    if (site === "1") {
      setOrderInitial((prvData: any) => {
        return { ...prvData, orderRef: values.orderRef, orderName: values.orderName }
      })
    } else {
      setSiteInitial((prvData: any) => {
        return { ...prvData, orderRef: values.orderRef, orderName: values.orderName }
      })
    }
    props.setSiteType(site);
    setSiteType(site);
  };


  const [open, setOpen] = React.useState(false);
  const getConfirmResponse = (action: string) => {
    if (action === 'Exit') {
      navigate('/orders');
    } else if (action === 'Continue Editing') {
      setOpen(false);
    }
  }

  useEffect(() => {
      setSiteInitial(prvdata => ({ ...prvdata, enterpriseid: enterpriseId, timezone: customerTimeZone, customer: selectedCustomer, 
      }));
    }, [enterpriseId])

  useEffect(() => {
    if (props.step1FormValues) {
      setSiteType("1");
      //if (props.siteType === "1") {
      if(props.siteInfo) {
        setEnterpriseId(props.step1FormValues.enterpriseid);
        setPartnerId(props.step1FormValues.partnerId);
        //fetchSiteDevice();
      }


      setSites(props.customerWiseSiteList);
      setOrderInitial(prvData => ({
        ...prvData,
        customer: props.step1FormValues.customer,
        enterpriseid: props.step1FormValues.enterpriseid,
        orderName: props.step1FormValues.orderName,
        orderRef: props.step1FormValues.orderRef,
        siteId: props.step1FormValues.siteId,
      }));
      //}
      /*  else if (props.siteType === "2") {
        //setCountryList(props.customerFormValues.countryList);
        setFilteredStateList(props.filteredStateList);
        setFilteredCityList(props.filteredCityList);
        setSiteInitial(prvData => ({
          ...prvData,
          orderName: props.step1FormValues.orderName,
          orderRef: props.step1FormValues.orderRef,
          customer: props.step1FormValues.customer,
          enterpriseid: props.step1FormValues.enterpriseid,
          name: props.step1FormValues.name,
          uniqueid: props.step1FormValues.uniqueid,
          email: props.step1FormValues.email,
          number: props.step1FormValues.number,
          addressline1: props.step1FormValues.addressline1,
          postalcode: props.step1FormValues.postalcode,
          country: props.step1FormValues.country,
          state: props.step1FormValues.state,
          city: props.step1FormValues.city,
        }));
      } */
    }
  }, [props.step1FormValues])


  // console.log(sites)
  return (
    <>
      <Formik initialValues={siteType === "1" ? orderInitial : siteInitial}
        enableReinitialize={true} // Enable reinitialization
        validationSchema={siteType === "1" ? validationSchemaForOrder : validationSchemaForSite}
        onSubmit={async (values, { setSubmitting }) => {

          console.log("Form Values ==== >>>")
          console.log(values)

          if (siteType === "1") {
            let tmp_values: any = { ...values };
            tmp_values['partnerId'] = partnerId;
            props.setStep1FormValues(tmp_values);
            props.setOrderInfo(tmp_values)
            props.setActiveStep(1);
          } else if (siteType === "2") {
            let tmp_values: any = { ...values };
            //let tmp_values2: any = { ...values };
            //console.log("values", tmp_values2);
            tmp_values.country = country;
            tmp_values.state = state;
            tmp_values.city = city;
            tmp_values.timezone = customerTimeZone;
            tmp_values.redirecturl = "/auth/set-password?uk=";
            const formData = new FormData();
            Object.keys(tmp_values).map(item => {
              formData.append(item, tmp_values[item]);
            })

            const resp = await postMethodFormData("customer/site", formData);
            console.log(resp)
            if (resp?.status === 200) {
              tmp_values['siteId'] = (resp?.data?.result?.[0]?.siteId).toString();
              tmp_values['partnerId'] = partnerId;
              console.log(tmp_values);
              props.setSiteInfo(resp?.data?.result?.[0]);
              props.setOrderInfo(tmp_values);
              props.setStep1FormValues(tmp_values);
              props.setActiveStep(1);
            } else {
              setToast(resp?.data?.message, "error");
            }
          }
        }}


      >

        {({ values, errors, isSubmitting, isValid, setFieldValue, touched }) => (
          <React.Fragment>
            <ToastContainer />
             {/* {JSON.stringify(values, null, 2)} */}
            <Form autoComplete="off" style={{ marginBottom: "150px" }}>
              <Row className="mb-3">
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <RBFORM.Group>
                      <RBFORM.Label className="label">Order Name</RBFORM.Label>
                      <Field
                        name="orderName"
                        type="text"
                        placeholder="Enter Order Name"
                        component={TextField}
                        className="inputC"
                        onChange={(e: any) => handleOrderName(e.target.value, setFieldValue, siteType)}
                      />
                    </RBFORM.Group>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <RBFORM.Group>
                      <RBFORM.Label className="label">Order Reference (Optional)</RBFORM.Label>
                      <Field
                        name="orderRef"
                        type="text"
                        placeholder="Enter Order Reference"
                        component={TextField}
                        className="inputC"
                        onChange={(e: any) => handleOrderRef(e.target.value, setFieldValue, siteType)}
                      />
                    </RBFORM.Group>
                  </Grid>
                </Grid>
              </Row>
              <Row className="mb-3" style={{ marginTop: '30px' }}>
                <Grid container className="titleTagIo1" spacing={3} style={{ fontSize: "20px", marginBottom: "20px" }}>
                  {siteType === "1" ? "Select Customer" : "Customer Details"}
                </Grid>
              </Row>
              {siteType === "1" &&
                <Row className="mb-3">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>

                      <RBFORM.Group>
                        <RBFORM.Label className="label">Select Customer<span style={{ color: "red" }}>*</span></RBFORM.Label>
                        <Field
                          name="customer"
                          as="select"
                          placeholder="Select Customer"
                          className="inputC custDropdown"
                          onChange={(e: any) => { setFieldValue("customer", e.target.value); handleSelectCustomer(e, setFieldValue) }}
                          style={{ marginBottom: '10px !important' }}
                        >
                          <option value=''>Select Customer</option>
                          {customers?.length > 0 &&
                            customers.map((customer: any) => (
                              <option key={customer.id} value={customer.name}>
                                {customer.name}
                              </option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="customer">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px", marginTop: "-18px", marginBottom: "10px" }}>{error}</Typography>}</ErrorMessage>
                      </RBFORM.Group>
                    </Grid>
                  </Grid>
                </Row>
              }
              <Row className="mb-3">
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{ mb: 2, mt: 4}} style={{ backgroundColor: "#192529", borderRadius: "30px", color: "#E2E3E3", fontSize: "14px" }}>

                      <RadioGroup
                        name="validity"
                        row
                        value={siteType}
                        onChange={(e: any) => handleSiteTypeChange(e.target.value, values)}
                      >
                        <FormControlLabel value="1" control={<Radio />} label="Existing Site / Device" />
                        <FormControlLabel value="2" control={<Radio />} label="New Site / Device" />
                      </RadioGroup>
                    </Box>
                  </Grid>


                </Grid>
              </Row>

              {siteType == "1" ?
                <Row className="mb-3">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>

                      <RBFORM.Group>
                        <RBFORM.Label className="label">Select Existing Site / Device<span style={{ color: "red" }}>*If the Site/Device is not displayed for this customer, there is already an active order.  Modify the existing Site/Device Order on the Orders Page. </span></RBFORM.Label>
                        <Field
                          name="siteId"
                          as="select"
                          placeholder="Select Customer"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleSiteChange(e, setFieldValue)}
                        >
                          <option value=''>Select Site / Device</option>
                          {sites?.length > 0 &&
                            sites.map((site: any) => (
                              <option key={site.siteId} value={site.siteId}>
                                {site.name}
                              </option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="siteId">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px", marginTop: "-18px", marginBottom: "10px" }}>{error}</Typography>}</ErrorMessage>
                      </RBFORM.Group>
                    </Grid>


                  </Grid>

                </Row> : <>
                  {/* {JSON.stringify(values, null, 2)} */}
                  <Row>
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Select Customer<span style={{ color: "red" }}>*</span></RBFORM.Label>
                          <Field
                            name="customer"
                            as="select"
                            placeholder="Select customer"
                            className="inputC custDropdown"
                            onChange={(e: any) => { setFieldValue("customer", e.target.value); handleSelectCustomer(e, setFieldValue) }}
                          >
                            <option value=''>Select Customer</option>
                            {customers?.length > 0 &&
                              customers.map((customer: any) => (
                                <option key={customer.id} value={customer.name}>
                                  {customer.name}
                                </option>
                              ))
                            }
                          </Field>
                          <ErrorMessage name="customer">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px" }}>{error}</Typography>}</ErrorMessage>
                        </RBFORM.Group>
                      </Grid>


                      <Grid size={{ xs: 12, md: 6 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Site / Device Name<span style={{ color: "red" }}>*</span></RBFORM.Label>
                          <Field
                            name="name"
                            type="text"
                            component={TextField}
                            className="inputC"
                          >
                          </Field>
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Unique ID<span style={{ color: "red" }}>*</span></RBFORM.Label>
                          <Field
                            name="uniqueid"
                            type="text"
                            placeholder="Enter unique ID"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Type<span style={{ color: "red" }}>*</span></RBFORM.Label>
                          <Field
                            name="type"
                            as="select"
                            placeholder="type"
                            className="inputC custDropdown"
                          >
                            <option value="EDGE">EDGE</option>
                            <option value="CLOUD">CLOUD</option>
                          </Field>
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Email ID</RBFORM.Label>
                          <Field
                            name="email"
                            type="text"
                            placeholder="Enter email ID"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid>
                     
                    </Grid>
                  </Row>

                  <Row className="mb-3" style={{ marginBottom: "70px" }}>
                    <Grid container columnSpacing={3} rowSpacing={0}>
                      {/* <Grid size={{ xs: 12, md: 12 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Address</RBFORM.Label>
                          <Field
                            name="addressline1"
                            type="text"
                            placeholder="Address Line 1"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid> */}
                      <Grid size={{ xs: 12, md: 6 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Address Line 1</RBFORM.Label>
                          <Field
                            name="addressline1"
                            type="text"
                            placeholder="Address Line 1"
                            component={TextField}
                            className="inputC"

                          />
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 6 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Address Line 2</RBFORM.Label>
                          <Field
                            name="addressline2"
                            type="text"
                            placeholder="Address Line 2"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Country</RBFORM.Label>
                          <Field
                            name="country"
                            as="select"
                            className="inputC custDropdown"
                            onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                          >
                            <option value=''>Select Country</option>
                            {countryList?.length > 0 &&
                              countryList.map((country: any) => (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              ))
                            }
                          </Field>
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">State/Province</RBFORM.Label>
                          <Field
                            name="state"
                            as="select"
                            placeholder="State"
                            className="inputC custDropdown"
                            onChange={(e: any) => { handleStateChange(e, setFieldValue) }}
                          >
                            <option value=''>Select State</option>
                            {filteredStateList?.length > 0 &&
                              filteredStateList.map((state: any) => (
                                <option key={state.id} value={state.id}>
                                  {state.name}
                                </option>
                              ))
                            }
                          </Field>
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">City</RBFORM.Label>
                          <Field
                            name="city"
                            as="select"
                            placeholder="City"
                            className="inputC custDropdown"
                            onChange={(e: any) => handleCityChange(e, setFieldValue)}
                          >
                            <option value=''>Select City</option>
                            {filteredCityList?.length > 0 &&
                              filteredCityList.map((city: any) => (
                                <option key={city.id} value={city.id}>
                                  {city.name}
                                </option>
                              ))
                            }
                          </Field>
                        </RBFORM.Group>
                      </Grid>

                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Zipcode/Postcode</RBFORM.Label>
                          <Field
                            name="postalcode"
                            type="text"
                            placeholder="Enter Postal Code"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid>


                      <Grid size={{ xs: 12, md: 4 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                          <Field
                            name="number"
                            type="text"
                            placeholder="Phone Number"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid></Grid>

                    <Grid container columnSpacing={3} rowSpacing={0}>
                      <Grid size={{ xs: 12, md: 4 }} >
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Timezone</RBFORM.Label>
                          <Field
                            name="timezone"
                            as="select"
                            className="inputC custDropdown"
                            onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                            style={{ cursor: "pointer" }}
                          >
                            <option value="" disabled>Select</option>
                            {timezoneList.map((tz) => (
                              <option key={tz.value} value={tz.value}>
                                {tz.label}
                              </option>
                            ))}

                          </Field>
                        </RBFORM.Group>
                      </Grid>
                    </Grid>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>
                          <img src={noteIcon} style={{ width: "20px", height: "20px" }} />
                        </span>
                        <span
                          className="label"
                          style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
                        >
                          Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
                        </span>
                      </div>

                   
                  </Row>
                </>
              }




              <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                sx={{
                  backgroundColor: '#03171F',
                  boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                }}>
                <Button onClick={() => setOpen(true)} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                  Cancel
                </Button>

                <Button
                  disabled={isSubmitting}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={isSubmitting ? <CircularProgress size="0.9rem" /> : undefined}
                  className="btnBlue"
                  sx={{
                    color: '#1F2F34', height: '41px', lineHeight: '41px',
                    borderColor: '#0B4A62', background: '#17B2EB !important',
                    borderRadius: '25px', fontSize: '14px',
                    fontWidth: '500',
                  }}
                  onClick={() => setFieldValue("submitButtonType", "next")}
                >
                  {isSubmitting ? "Creating..." : "Next"}
                </Button>
              </Stack>
            </Form>
          </React.Fragment>
        )}
      </Formik >

      <AlertDialogs
        open={open}
        setOpen={setOpen}
        getConfirmResponse={getConfirmResponse}
        title="Cancel Order Creation"
        message="Are you sure want to cancel creating the order?<br/>Any information entered will not be saved.<br/><br/>Click 'Exit' to confirm cancellation."
        button1="Continue Editing"
        button2="Exit"
      />
    </>
  )
}

export default OrderCreateStep1SiteDevice